<h2 mat-dialog-title>
  {{title | translate}}
</h2>
<mat-dialog-content class="content-padding">
  <div [innerHtml]="body"></div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>
